import { z } from 'zod';
import { timestampSchema } from './shared';

export const testimonialRowSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  role: z.string(),
  quote: z.string(),
  image: z.string().nullable(),
  sortOrder: z.number().int(),
  visible: z.boolean(),
  updatedAt: timestampSchema,
});

// id auto-generated by crudRoutes (randomUUID); accepted if client provides it.
export const testimonialInsertSchema = z.object({
  id: z.string().min(1).optional(),
  name: z.string().min(1),
  role: z.string(),
  quote: z.string(),
  image: z.string().nullable().optional(),
  sortOrder: z.number().int().optional(),
  visible: z.boolean().optional(),
});

export const testimonialUpdateSchema = testimonialInsertSchema.partial();

export type TestimonialRow = z.infer<typeof testimonialRowSchema>;
export type TestimonialInsert = z.input<typeof testimonialInsertSchema>;
export type TestimonialUpdate = z.input<typeof testimonialUpdateSchema>;
